import color from 'dojo/_base/Color';
import domAttr from 'dojo/dom-attr';
import domStyle from 'dojo/dom-style';
import domClass from 'dojo/dom-class';
import domConstruct from 'dojo/dom-construct';

const w = window as any;

if (typeof (w.moreCore) == "undefined") {

    w.moreCore = {
        Tools: {
            UiModder: {}
        }
    }
}



w.moreCore.Tools.UiModder.color = color;
w.moreCore.Tools.UiModder.domAttr = domAttr;
w.moreCore.Tools.UiModder.domClass = domClass;
w.moreCore.Tools.UiModder.domConstruct = domConstruct;
w.moreCore.Tools.UiModder.domStyle = domStyle;


w.moreCore.Tools.UiModder.domAttr.setMultiple = function (elements: any, targetAttr: any, content: any) {
    if (elements?.length) {
        for (let element of elements) {
            w.moreCore.Tools.UiModder.domAttr.set(element, targetAttr, content);
        }
    }
};
w.moreCore.Tools.UiModder.domClass.addMultiple = function (elements: any, classname: any) {
    if (elements?.length) {
        for (let element of elements) {
            w.moreCore.Tools.UiModder.domClass.add(element, classname);
        }
    }
};
w.moreCore.Tools.UiModder.domClass.removeMultiple = function (elements: any, classname: any) {
    if (elements?.length) {
        for (let element of elements) {
            w.moreCore.Tools.UiModder.domClass.remove(element, classname);
        }
    }
};

w.moreCore.Tools.UiModder.domClass.toggleMultiple = function (elements: any, classname: any, flag: any) {
    if (elements?.length) {
        for (let element of elements) {
            w.moreCore.Tools.UiModder.domClass.toggle(element, classname, flag);
        }
    }
};

export default w.moreCore.Tools.UiModder;
